import { Dictionary,Resource } from "./Dictionary";

(window as any).Dictionary=Dictionary;
(window as any).Resource=Resource;

import { DistributeAndCommissionDictionary,DistributeAndCommissionSource } from "./DistributeAndCommissionDictionary";
(window as any).DistributeAndCommissionDictionary=DistributeAndCommissionDictionary;
(window as any).DistributeAndCommissionSource=DistributeAndCommissionSource;

import { ErpDictionary,ErpSource } from "./ErpDictionary";
(window as any).ErpDictionary=ErpDictionary;
(window as any).ErpSource=ErpSource;


import { FinanceDictionary,FinanceSource } from "./FinanceDictionary";
(window as any).FinanceDictionary=FinanceDictionary;
(window as any).FinanceSource=FinanceSource;


import { PurchaseOrderDictionary,PurchaseOrderSource } from "./PurchaseOrderDictionary";
(window as any).PurchaseOrderDictionary=PurchaseOrderDictionary;
(window as any).PurchaseOrderSource=PurchaseOrderSource;

import { MaterialDataOptionsDictionary } from "./MaterialDataOptionsDictionary";
(window as any).MaterialDataOptionsDictionary=MaterialDataOptionsDictionary;

import { SiteSettingDictionary,SiteSettingSource } from "./SiteSettingDictionary";
(window as any).SiteSettingDictionary=SiteSettingDictionary;
(window as any).SiteSettingSource=SiteSettingSource;